import { FC, useEffect, useState } from "react"
import { observer } from "mobx-react"
import { useStore } from "stores/utils/use-store"
import { TablePaginationConfig } from "antd/lib/table/interface"
import { Modal, Table } from "antd"
import { Booster } from "domains/boosters/store/boosters.store"
import { boosterColumns } from "./columns"
import { BoosterEdit } from "domains/boosters/components/booster.edit"
import { Column } from "abstract/types/column.type"
import { DeleteIconButton, showDeleteConfirm, CreateNewElement } from "components"

export const BoostersList: FC = observer(() => {
  const { dataStore: { boostersStore } } = useStore()
  const [isVisibleEditCreate, setEditCreateVisibility] = useState<"create" | "edit" | null>(null)

  const paginationOptions: TablePaginationConfig = {
    onChange: async page => {
      boostersStore.pagination.page = page
    },
    total: boostersStore.total,
    showTotal: (total, range) => `${range[0]} to ${range[1]} of ${total}`,
    defaultPageSize: 10,
  }

  useEffect(() => {
    boostersStore.getData()
  }, [boostersStore])

  const onClose = () => {
    boostersStore.clearElement()
    setEditCreateVisibility(null)
  }

  const columns: Column[] = [
    ...boosterColumns,

    {
      title: "Delete",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (_: any, row: any) => (
        <DeleteIconButton
          onClick={e => {
            e.stopPropagation()
            showDeleteConfirm(`market item: ${row.name}`, undefined, async() => {
              boostersStore.funcAfterSuccess = async() => await boostersStore.getData()
              boostersStore.delete(row.id)
            })
          }}
        />
      ),
    },
  ]

  return (
    <>
      <CreateNewElement onClick={() => setEditCreateVisibility("create")} valueText="booster" />
      <Table
        dataSource={boostersStore.boosters}
        columns={columns as any}
        rowKey="id"
        pagination={paginationOptions}
        loading={boostersStore.isLoading}
        onRow={(record: Booster) => ({
          onClick: () => {
            boostersStore.selectedElement = record
            setEditCreateVisibility("edit")
          },
        })}
      />

      {isVisibleEditCreate && (
        <Modal
          visible
          title={isVisibleEditCreate === "edit" ? "Edit booster" : "Create booster"}
          width="700px"
          footer={null}
          onCancel={onClose}
          style={{ top: "10px" }}
        >
          <BoosterEdit editType={isVisibleEditCreate} onClose={onClose} />
        </Modal>
      )}
    </>
  )
})
